import React, {PureComponent} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Provider from "pubsub-js";
import {setFillForPathOfStaticObject} from "../AC/set-fill-for-path-of-static-object";
import ColorPicker from "./ColorPicker";
import {conditionSelector} from "../selectors";
import productSettings from "../services/product-settings";
import withErrorBoundary from "../decorators/withErrorBoundary";
import {CANVAS_MODIFIED} from "../constants/event-types";

class StaticObjectControl extends PureComponent {
  static propTypes = {
    condition: PropTypes.object,
    setFillForPathOfStaticObject: PropTypes.func
  };
  state = {
    colors: []
  };
  changeColor = (pathNumber) => (color) => {
    const {r, g, b, a} = color.rgb;
    const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;

    this.props.setFillForPathOfStaticObject(rgba, pathNumber);
  };
  hasProductStaticObject() {
    const {
      condition: {side, product}
    } = this.props;
    const settigns = productSettings[product];
    return settigns && settigns.objectToLoad && settigns.objectToLoad[side];
  }
  onFillChanged = (_, staticObject) => {
    const colors = staticObject.getObjects().map((object) => object.fill);
    this.setState({
      colors
    });
  };
  setInitialValues = (_, design) => {
    if (design.objects) {
      const staticObject = design.objects.filter((o) => o.static)[0];
      if (staticObject) {
        const colors = staticObject.objects
          ? staticObject.objects.map((object) => object.fill)
          : [staticObject.fill];
        this.setState({
          colors
        });
      }
    }
  };
  componentDidMount() {
    Provider.subscribe(CANVAS_MODIFIED, this.setInitialValues);
  }
  componentWillUnmount() {
    Provider.unsubscribe(CANVAS_MODIFIED, this.setInitialValues);
  }
  getColor(pathNumber) {
    return this.state.colors[pathNumber];
  }
  render() {
    const {
      condition: {product}
    } = this.props;

    if (
      !productSettings[product] ||
      !productSettings[product].loadedObjectSettings
    ) {
      return null;
    }

    return this.hasProductStaticObject() ? (
      <div className="panel-control">
        <div className="panel-control__title">
          {productSettings[product].loadedObjectSettings.title}
        </div>
        <div className="panel-control__content">
          <div className="loaded-object-settings-list">
            {productSettings[product].loadedObjectSettings.colorPickers.map(
              ({label, pathNumber}) => (
                <div key={label} className="loaded-object-settings">
                  <div className="loaded-object-settings__pallete">
                    <ColorPicker
                      color={this.getColor(pathNumber)}
                      onChange={this.changeColor(pathNumber)}
                    />
                  </div>
                  {label && (
                    <div className="loaded-object-settings__label">{label}</div>
                  )}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default connect(
  (state) => ({
    condition: conditionSelector(state)
  }),
  {
    setFillForPathOfStaticObject
  }
)(withErrorBoundary(StaticObjectControl));
